import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AdvisoryMessageComponent } from './advisory-message.component';

@NgModule({
  declarations: [AdvisoryMessageComponent],
  imports: [CommonModule],
  exports: [AdvisoryMessageComponent],
  bootstrap: [AdvisoryMessageComponent]
})
export class AdvisoryMessageModule {}
